module.exports = __webpack_public_path__ + "img/introducepinxdetail_bodyimage01.2d87745b.jpg";